<script lang="ts">
  import { Environment } from '@squareup/public-web-browser-helpers/environment';
  import { showToast, Tooltip } from '@squareup/public-web-design-system';
  import { componentLibrary } from '../../../store/componentLibrary';
  import { logComponentError } from '$lib/helpers/browser/log-helper';

  const {
    children,
    passThroughProps = {},
  }: {
    children: any;
    passThroughProps?: any;
  } = $props();

  const isProduction = Environment.env === 'production';
  const normalizedChildren = $derived(Array.isArray(children) ? children : [children]);

  function getErrorMessage(componentName: string) {
    return `RENDER_FAILURE: Failed to render component: ${componentName}. Check the dev server logs or the console for more details.`;
  }

  function onError(componentName: string, e: unknown) {
    const renderingError = new Error(getErrorMessage(componentName), { cause: e });
    logComponentError(componentName, renderingError);
    if (!isProduction) {
      showToast(renderingError.message, { error: true, duration: 3 * 60 * 1000 });
    }
  }
</script>

{#snippet childComponent(componentName: string, props: any)}
  {@const SvelteComponent = $componentLibrary[componentName]}
  <SvelteComponent {...props} {...passThroughProps} />
{/snippet}

{#each normalizedChildren as child}
  {#if $componentLibrary[child.componentName]}
    <svelte:boundary onerror={(e) => onError(child.componentName, e)}>
      {@render childComponent(child.componentName, child.props)}

      {#snippet failed()}
        {#if isProduction}
          {@render childComponent(child.componentName, child.props)}
        {:else}
          <Tooltip>
            {#snippet bodyText()}
              {getErrorMessage(child.componentName)}
            {/snippet}
          </Tooltip>
        {/if}
      {/snippet}
    </svelte:boundary>
  {/if}
{/each}
